<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商品抵扣列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_name"
                    placeholder="商品名称"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.wdid"
                    placeholder="抵扣商品ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.market_name"
                    placeholder="市场"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.city"
                    multiple
                    placeholder="选择城市"
                  >
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.brand_name"
                    placeholder="品牌"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.woid"
                    placeholder="代采单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.pg_id" placeholder="选择买手组">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionPicker"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select v-model="form.pgid" placeholder="选择代采组">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionPurchase"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="resData">
                  <el-select v-model="form.referer" placeholder="请选择来源">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionReferer"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="resData">
                  <el-select v-model="form.status" placeholder="请选择状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionStatus"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="resData">
                  <el-select v-model="form.pay_type" placeholder="交易类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.optionPayType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData" label="">
                  <el-select
                    v-model="form.order_owner"
                    filterable
                    placeholder="订单负责人"
                  >
                    <el-option :key="0" value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in resData.owner_option"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.dgid"
                    filterable
                    placeholder="次品组"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.dg_group"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.dpc_id"
                    filterable
                    placeholder="退换货负责人"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.option_dgm"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.refunder_id"
                    filterable
                    placeholder="售后退供员"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.dgm_refunder"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="resData">
                  <el-select
                    v-model="form.ded_source"
                    filterable
                    placeholder="生成渠道"
                  >
                    <el-option
                      v-for="item in constantMap.optionsSource"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.stock_out_create_admin_str"
                    placeholder="扫码出库人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="订单生成时间：">
                  <el-date-picker
                    v-model="form.order_time"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="待抵扣生成时间：">
                  <el-date-picker
                    v-model="form.time"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="使用抵扣时间：">
                  <el-date-picker
                    v-model="form.use_ded_time"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="退换货生成时间">
                  <el-date-picker
                    v-model="form.stock_out_create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col v-if="resData" :span="24" class="data-statics">
        数据汇总&nbsp;&nbsp;&nbsp;&nbsp;
        <span
          >待抵扣数量：{{
            resData.total.wait_ded_num
          }}件&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span
          >部分抵扣(坏账)数量：{{
            resData.total.part_ded_num
          }}件&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span
          >已抵扣数量：{{
            resData.total.done_ded_num
          }}件&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span
          >待抵扣金额：¥{{
            resData.total.wait_ded_amount
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
        <span
          >已抵扣金额：¥{{
            resData.total.part_ded_amount
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
        >
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="danger"
            size="mini"
            @click="handleGoodsChangeOwn"
            >转欠货</el-button
          >
          <el-button type="success" size="mini" @click="output">导出</el-button>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            :key="'table1'"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              :selectable="isRowSelectable"
            >
            </el-table-column>
            <el-table-column prop="wdid" label="抵扣商品ID" align="center">
            </el-table-column>
            <el-table-column align="center" prop="goods_img" label="商品图片">
              <template #default="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="商品货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column align="center" prop="ded_doc" label="抵扣凭证">
              <template #default="scope">
                <div
                  v-if="scope.row.ded_doc"
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.ded_doc"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="num"
              label="数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_name"
              label="买手组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="owner_admin_name"
              label="订单负责人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dg_group_name"
              label="次品组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_name"
              label="退换货负责人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refunder"
              label="售后退供员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="woid"
              label="代采单"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="order_time"
              label="订单生成时间"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="work_id"
              label="工单id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="代采价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pay_type"
              label="交易类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status"
              label="抵扣状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="balance"
              label="待抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ded_price"
              label="已抵扣金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="referer"
              label="来源"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ded_source_text"
              label="生成渠道"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="操作人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="待抵扣生成时间"
              width="120"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="use_ded_time"
              label="使用抵扣时间"
              width="120"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ded_woid"
              label="使用的代采单号"
              width="120"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="stock_out_create_admin_str"
              label="扫码出库人"
              show-overflow-tooltip
              align="center"
              width="90"
            >
            </el-table-column>
            <el-table-column
              prop="stock_out_create_time"
              label="退换货生成时间"
              show-overflow-tooltip
              align="center"
              width="150"
            >
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst.js";
import apiBaseURL from "@/utils/baseUrl.js";
import { postDedTransferOut } from "@/openapi/erp/deduction.js";

const constantMap = Object.freeze({
  optionsSource: [
    { label: "全部", value: "0" },
    { label: "一手", value: "1" },
    { label: "爆版", value: "2" },
  ],
  defSource: "0",
});

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.wdid) {
        vm.form.wdid = to.query.wdid;
        vm.form.time = [];
      }
      vm.fetchData();
    });
  },
  data() {
    return {
      constantMap,
      resData: null,
      form: {
        status: "",
        time: this.defaultDate(),
        city: [],
        wdid: "",
        ded_source: constantMap.defSource,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Deduction/goodsDedList",
      status: "",
      curPage: 1,
      filterFold: false,
      citys: CITY,
      multipleSelection: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    handleGoodsChangeOwn() {
      if (!this.multipleSelection.length) {
        this.$message.info("请选择商品");
        return;
      }
      const params = {
        wdids: this.multipleSelection.map((item) => item.wdid),
      };
      this.$confirm("确定转欠货吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          postDedTransferOut(params)
            .then(() => {
              this.$message.success("操作成功");
              this.fetchData();
            })
            .catch(this.$noop);
        })
        .catch(this.$noop);
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(`/home/purchaseorderdetail/${row.woid}`);
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    selectStatus(key) {
      this.loading = true;
      this.form.status = this.status = key;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    defaultDate() {
      return this.$excalibur.getDateRange(6, true);
    },
    isRowSelectable(row) {
      return row.status_int === "0";
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseDeduction.vue